<template lang="pug">
    div
</template>
<script>
import { _logout } from "@/api/user";

export default {
    name: "Dashboard",
    props: ["userData"],
    data() {
        return {};
    },
    methods: {
        logout() {
            _logout()
                .then(response => {
                    // 只清除使用者資料及群組 query，不可使用 LOGOUT 重置所有狀態，因會使客戶（ex: A8）客製化樣式被重置
                    this.$store.commit("SET_USER_DATA", {});
                    this.$store.commit("SET_QUERY_GROUPNAME", "");
                    this.$router.push({ name: "login", query: {} });
                })
                .catch(errors => {
                    console.log(errors);
                    this.$store.commit("SET_USER_DATA", {});
                    this.$store.commit("SET_QUERY_GROUPNAME", "");
                    this.$router.push({ name: "login", query: {} });
                });
        }
    },
    mounted() {
        this.logout();
    }
};
</script>



// WEBPACK FOOTER //
// src/view/general/Logout.vue